// extracted by mini-css-extract-plugin
module.exports = {"radio":"Form_radio__cIOED","checkbox":"Form_checkbox__C5qz7"};